import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-5 text-center">
          * * *
        </p>

        <p class="poem-block mb-3">
          Не признаю в берёзе красоты!<br/>
          Акация мне ближе и милее.<br/>
          Весной на ней душистые цветы,<br/>
          А осенью она листвой алеет…
        </p>
        
        <p class="poem-block mb-3">
          Жара. Конец июня настаёт.<br/>
          От зноя весь дрожжит расплавившийся город.<br/>
          А в переулках снегопад идёт<br/>
          И снег горячий медленно летит тебе за ворот<br/>
          И медленно ложится на асфальт.<br/>
          И воздух, весь горящий,<br/>
          Насыщен запахом акации летящей…
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Не признаю в берёзе красоты'
}


const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;